import React, { useContext } from 'react';
import AppContext from '../../Context/AppContext';
import {Navbar, RoomNavbarContainer, Title, SimpleText} from '../style';
import Timer from '../Timer';

const RoleNavbar = (props) => {
    const {turn, isGameStarter, username} = useContext(AppContext);

    return (
        <Navbar>
            <SimpleText>{turn}</SimpleText>
            <RoomNavbarContainer>
                <Title>Werewolf</Title>
                <SimpleText>{username}</SimpleText>
            </RoomNavbarContainer>            
            {isGameStarter && <Timer {...props}/>}
        </Navbar>
    );
}

export default RoleNavbar;